import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { Layout, Loading, usePageTitle } from "@/components/site/Layout";
import { Hero } from "@/components/site/Hero";
import { Welcome, Space, Amenities, Location } from "@/components/site/Sections";
import { Gallery } from "@/components/site/Gallery";
import { GoodToKnow, Reputation, Faqs } from "@/components/site/InfoSections";
import { useSite } from "@/context/SiteContext";
import { api, money } from "@/lib/api";

const MobileBookBar = ({ site }) => (
  <div className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-background border-t border-border px-5 py-3 flex items-center justify-between" data-testid="mobile-book-bar">
    <p className="text-sm"><strong>{money(site.pricing.nightly_rate)}</strong> / night{site.pricing.is_sample && <span className="block text-[10px] uppercase tracking-wider text-[hsl(30_60%_35%)]">Sample rate</span>}</p>
    <div className="flex items-center gap-2">
      <a href="tel:+14093653256" aria-label="Call (409) 365-3256" className="border border-primary p-2.5 rounded-full" data-testid="mobile-call-button"><Phone className="w-4 h-4" /></a>
      <Link to="/book" className="bg-primary text-primary-foreground px-5 py-2.5 rounded-full text-sm font-semibold" data-testid="mobile-check-availability">Check Availability</Link>
    </div>
  </div>
);

export default function Home() {
  const { site, error } = useSite();
  const { hash } = useLocation();
  usePageTitle("Garage Getaway Beaumont | Private Studio Rental near St. Elizabeth Hospital, Beaumont TX");
  useEffect(() => {
    api.post("/track", { type: "home_view" }).catch(() => {});
  }, []);
  useEffect(() => {
    if (site && hash) document.querySelector(hash)?.scrollIntoView();
  }, [site, hash]);
  return (
    <Layout>
      {error && <p className="p-10 text-center" data-testid="site-error">We couldn't load the site right now. Please refresh.</p>}
      {!site && !error ? <Loading /> : site && (
        <>
          <Hero />
          <Welcome />
          <Space />
          <Amenities />
          <Gallery />
          <Location />
          <GoodToKnow />
          <Reputation />
          <Faqs />
          <MobileBookBar site={site} />
        </>
      )}
    </Layout>
  );
}
